// @ts-expect-error: To handle any unhandled errors on the server
//import { logger } from '@nuxt-common/util/app/utils/universalLogger/server-side-launcher';
/**
 * This plugin handles client-side errors.
 * Catch all client side error handler
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.error('Nuxt Vue Error Handler: ', error, info, instance);
  };

  nuxtApp.hook('vue:error', (error, instance, info) => {
    // handle error
    //* TODO use logger here
    //logger.error(`[Vue Error]: ${error}, Component instance: ${instance}, Error info: ${info}`);
    console.error('[Vue Error]', error);
    console.error('Component instance:', instance);
    console.error('Error info:', info);
  });
});
